import React, { useEffect } from 'react'
import ReviewForm from './ReviewForm';
import { useTranslation } from 'react-i18next';
import LoadingSpinner from '../global/LoadingSpinner';
import { useState } from 'react';
import LanguagesSelector from './LanguagesSelector';
import ImageWithFallback from '../global/ImageWithFallback';
import ThankYouModal from './ThankYouModal';
import { displayName } from '../../helpers/templateHelpers';

import { useGetCompany } from '../../hooks/public/Companies';

export default function ReviewFromProfile({id = null, code = null}) {
  const { t, i18n } = useTranslation();
  const { data, isLoading, isError, refetch } = useGetCompany(id);
  const [lng, setLang] = useState(i18n.language.toUpperCase());
  const [ finish, setFinish ] = useState(false);

  useEffect(() => {
    setLang(i18n.language.toUpperCase());
}, [i18n.language]);


  if (isLoading) return <LoadingSpinner />
  if (isError) return 'An error has occurred: ' + isError.message;


  let number = 0;


if(finish)  return (<><ThankYouModal www={data.www} /> </>)


  return (
    <div className="reviewInvite">
      <div className="wrapper">
        <div className="container container-relative">
          <LanguagesSelector lang={data.languages} />
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-md-8 mx-auto">
              <section className="box invitation">
                <div className="content">
                  <div className="vendor">
                    <div className="row">
                      <div className="col-sm-12 text-center">
                        <ImageWithFallback src={data.logo_url} alt={data.logo_url} />
                        {!data.logo_url && <h2>{data.name}</h2>}
                      </div>
                    </div>
                  </div>
                  {data && <ReviewForm
                    id={data.id}
                    number={number++}
                    title={null}
                    subTitle={data.review_settings.title}
                    image={null}
                    displayElementDetails={true}
                    customerName={""}
                    customerSurname={""}
                    anonymous={data.anonymous_reviewing}
                    questionsData={data.questionsData}
                    prizeGame={data.prizeGame} 
                    prizeGameVisible={data.review_settings.showPrizeGame}
                    termsVisible={data.terms_of_use_visible} 
                    onSubmit={() => setFinish(true)}
                    data=	{{ 
                      type:"COMPANY",
                      sourceId:data.id,
                      company_id: data.id, 
                      user_id:null, 
                      text:null, 
                      score:null, 
                      answers:{}, 
                      language:lng,
                      group_id:null,
                      invitation_reference_number: code, 
                      product_id:null, 
                      source_id:null,
                      vendor_id:data.vendor_id,
                      customerName:'', 
                      customerSurname:'', 
                      prize_game: {},
                      prize_game_id:data.prizeGame?.id }} /> 
                  }
                  <p className="authorName">{t("review.revEn")}<strong> artur.com</strong></p>

                  {!data.anonymous_reviewing && data.customer_name && data.customer_surname &&
                  <p className="copyArtur">{t("review.disN")}: {displayName(data.customer_name, data.customer_surname)}</p>
                  }
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
